module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0018.jpg?v=eecc6228";